"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.listToDictionary = void 0;
const ramda_1 = require("ramda");
/**
 * Transform a list of values to dictionary
 *
 * @param idGen - Generator that return the key value
 * @param list - Array of values
 * @returns Dictionary of values
 *
 * @public
 *
 * @example
 * ```ts
 * const list = [
 *   { id: '1', name: 'value 1' },
 *   { id: '2', name: 'value 2' },
 * ];
 * const idGen = (item) => item.id;
 * const result = listToDictionary(idGen, list);
 * console.log(result);
 * // -> {
 * //   '1': { id: '1', name: 'value 1' },
 * //   '2': { id: '2', name: 'value 2' },
 * // }
 * ```
 */
function listToDictionary(idGen, list) {
    return (0, ramda_1.zipObj)((0, ramda_1.map)(idGen, list), list);
}
exports.listToDictionary = listToDictionary;
//# sourceMappingURL=list-to-dictionary.js.map